export const COMMUNITY_FILTERS = Object.freeze({
  ALL: 'all',
  FOLLOWING: 'following',
});

export function getCommunityFeedFilterConfig(filter) {
  const isFollowing = filter === COMMUNITY_FILTERS.FOLLOWING;

  return {
    value: isFollowing ? COMMUNITY_FILTERS.FOLLOWING : COMMUNITY_FILTERS.ALL,
    cacheKey: `home_community_${isFollowing ? COMMUNITY_FILTERS.FOLLOWING : COMMUNITY_FILTERS.ALL}_v2`,
    queryParams: isFollowing ? { only_following: 'true', pagination: 'cursor' } : { pagination: 'cursor' },
    injectToken: false,
    optionalToken: true,
  };
}
